import React from "react";
import NavBar from "./navBar/navBar";
import Footer from "./footer/footer";
import { Outlet, useLocation } from "react-router-dom";

type Phantom = {
  src: string;
  className: string;
};

const Layout = () => {
  const location = useLocation();

  const getPhantoms = (): Phantom[] => {
    if (location.pathname.includes("/articles")) {
      return [
        {
          src: "/images/phantom/fantome3.png",
          className: "absolute top-20 left-2 w-52 opacity-70",
        },
        {
          src: "/images/phantom/IMG_0453.png",
          className: "absolute bottom-72 right-0 w-40 opacity-70",
        },
        {
          src: "/images/phantom/fantome2.png",
          className: "absolute top-10 right-10 w-64 opacity-30",
        },
      ];
    }

    if (location.pathname.includes("/a-propos")) {
      return [
        {
          src: "/images/phantom/IMG_0450.png",
          className:
            "absolute top-1/2 left-0 transform -translate-y-1/2 w-72 rotate-[-340deg] opacity-50",
        },
        {
          src: "/images/phantom/IMG_0451.png",
          className: "absolute top-1/4 right-0 w-64 rotate-[325deg] opacity-70",
        },
      ];
    }

    return [
      {
        src: "/images/phantom/IMG_0456.png",
        className: "absolute top-20 left-0 w-72 opacity-80",
      },
      {
        src: "/images/phantom/IMG_0452.png",
        className: "absolute top-1/3 right-0 w-72  rotate-[325deg] opacity-70",
      },
    ];
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-[#FBFAF9]">
      {getPhantoms().map(({ src, className }, i) => (
        <img
          key={i}
          src={src}
          aria-hidden
          className={`pointer-events-none fixed z-0 hidden md:block opacity-70 ${className}`}
          loading="lazy"
        />
      ))}
      {/* Navigation */}
      <NavBar />

      {/* Contenu dynamique */}
      <main className="relative z-10 w-full max-w-7xl flex-grow mx-auto px-4 sm:px-8 lg:px-20 py-8 md:py-16">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
